import api from "@utils/api";

export const getTasksPaginated = (idOrg, page, perPage) =>
  api.get(`/tareas/organizacion/${idOrg}?page=${page}&per_page=${perPage}`);
export const createTask = (task) => api.post("/tareas/", task);

export const getTaskById = (id) => api.get(`/tareas/${id}`);
export const updateTask = (id, task) => api.put(`/tareas/${id}`, task);
export const deleteTask = (id) => api.delete(`/tareas/${id}`);

export const getExcelTasksS3 = async (organizacion_id) => {
  try {
    const response = await api.get(`/tareas/export/excel_s3?organizacion_id=${organizacion_id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel: ${error.message}`);
  }
};